var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4873 12.3848L43.42 43.401H6.58008L4.10938 12.985L24.9997 24.7639L46.4873 12.3848Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4482 6.54297L25.0015 25.8852L4.55469 6.54297H45.4482Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57999 15.4746V43.402H3.2422C2.63929 43.3999 2.06191 43.1584 1.63704 42.7306C1.21217 42.3028 0.974603 41.7238 0.976575 41.1209V11.3613L4.63644 11.4622L6.57999 15.4746Z",
    fill: "#F14336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0253 11.3615V41.1212C49.0272 41.7242 48.7894 42.3033 48.3644 42.7311C47.9394 43.1589 47.3618 43.4003 46.7588 43.4023H43.4219V15.4748L45.2698 11.0781L49.0253 11.3615Z",
    fill: "#D32E2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 8.82412V11.361L43.4199 15.4743L25 28.9944L6.58009 15.4743L0.976574 11.361V8.82412C0.974628 8.22122 1.21221 7.64222 1.63707 7.21444C2.06193 6.78667 2.63929 6.54514 3.2422 6.54297H4.55323L25 21.5507L45.4468 6.54297H46.757C47.3601 6.54499 47.9376 6.78644 48.3626 7.21422C48.7876 7.64201 49.0253 8.2211 49.0234 8.82412Z",
    fill: "#F14336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58008 15.4746L0.976562 14.5997V11.3613L6.58008 15.4746Z",
    fill: "#D32E2A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.0b9496f5b6779944a5c49587c8d91fab.svg";
export { ForwardRef as ReactComponent };